import { Toast } from "vant";

class Response {

  static CallResponse(response, callback) {
    if (response.code == 200) {
      if (response.result.status) {
        Toast.success(response.result.message);
      } else {
        Toast.fail(response.result.message);
      }
      callback(response.result);
    } else {
      const msg =
        (response && response.result && response.result.message) || "请求出错！";
      Toast.fail(msg);
    }
  }

  static callNotMsgResponse = (response, callback) => {
    if (response.code == 200) {
      callback(response.result);
    } else {
      const msg =
        (response && response.result && response.result.message) || "请求出错！";
      Toast.fail(msg);
    }
  };

}

export default Response;



// WEBPACK FOOTER //
// ./src/tools/response.js